import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(
  ({ palette, breakpoints, transitions: { easing } }) => ({
    faqItem: {
      marginBottom: rem(16),
      [breakpoints.up('lg')]: {
        marginBottom: rem(36),
      },
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      '&:hover, &:focus': {
        cursor: 'pointer',
      },
      marginTop: rem(16),
      [breakpoints.up('lg')]: {
        marginTop: rem(36),
      },
    },
    container: {
      flexGrow: 1,
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      marginBottom: rem(12),
    },
    title: {
      color: palette.neutral[300],
      flexGrow: 1,
      zIndex: 1,
    },
    titleIcon: {
      marginRight: rem(16),
      fontSize: rem(20),
      lineHeight: rem(32),
    },
    description: {
      color: palette.neutral.main,
      whiteSpace: 'pre-wrap',
      zIndex: -1,
    },
    icon: {
      alignSelf: 'right',
      opacity: 0.5,
      color: palette.neutral[200],
      '&:hover, &:focus': {
        opacity: 1,
      },
    },
    iconAnimationOpen: {
      animation: `$rotationOpen 200ms ${easing.easeInOut}`,
      opacity: 1,
      transform: 'rotate(180deg)',
    },
    iconAnimationClose: {
      animation: `$rotationClose 200ms ${easing.easeInOut}`,
      opacity: 0.5,
      transform: 'rotate(0deg)',
    },
    '@keyframes rotationOpen': {
      '0%': {
        opacity: 0.5,
        transform: 'rotate(0)',
      },
      '100%': {
        opacity: 1,
        transform: 'rotate(180deg)',
      },
    },
    '@keyframes rotationClose': {
      '0%': {
        opacity: 1,
        transform: 'rotate(180deg)',
      },
      '100%': {
        opacity: 0.5,
        transform: 'rotate(0)',
      },
    },
    divider: {
      color: palette.neutral[800],
    },
  })
);
